export default "__VITE_ASSET__psorBL5O__"